import { Injectable, OnDestroy, inject } from '@angular/core';
import { Auth, onAuthStateChanged, User as AuthUser, Unsubscribe } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import { Collection } from '../enums/collection.enum';
import { User } from '../models/user';
import { collection, collectionData, doc, Firestore, getDocs, limit, query, setDoc, where } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class UserService implements OnDestroy {
  
  private firestore = inject(Firestore);
  private _auth = inject(Auth);
  private _usersCollection: AngularFirestoreCollection<User>;
  public currentUser: AuthUser;
  public signedIn = false;
  private authSubscription?: Unsubscribe;
  constructor(private _firestore: AngularFirestore) {
    this._usersCollection = _firestore.collection<User>(Collection.Users);
    this.authSubscription = onAuthStateChanged(this._auth, async (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        this.currentUser = user;
        this.signedIn = true;
        
        if(await this.existsByUid(user.uid) == false){
          let newUser = new User();
          newUser.uid = user.uid;
          newUser.displayName = user.displayName;
          newUser.email = user.email;
          this.add(newUser);
        }
      } else {
        // User is signed out
        this.currentUser = null;
        this.signedIn = false;
      }
    });
  }
  ngOnDestroy(): void {
    if(this.authSubscription) {
      // unsubscribes
      this.authSubscription();
    }
  }
  list(){
    return this._usersCollection.valueChanges()
    .pipe(
      map(x => x.map(y => Object.assign(new User, y))),
    );
  }
  get(id: string){
    return this._usersCollection.doc(id).get();
  }
  getReferees(ids: string[]){
    const q = query(
      collection(this.firestore, Collection.Users),
      where('uid', 'in', ids),
    );
    return collectionData(q)
      .pipe(
        map(x => x.map(y => Object.assign(new User, y))),
      );
  }
  add(user: User) {
    const newUserRef = doc(collection(this.firestore, Collection.Users));
    const id = newUserRef.id
    user.id = id
    setDoc(newUserRef, Object.assign({}, user))
    return id;
  }
  async getByUid(uid: string){
    const q = query(
      collection(this.firestore, Collection.Users),
      where('uid', '==', uid),
      limit(1),
    );
    return await getDocs(q)
  }
  async existsByUid(id: string){
    const x = await this.getByUid(id);
    return x.size == 1
  }
}
